var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.views),function(ref){
var label = ref.label;
var icon = ref.icon;
return _c('button',{key:label,staticClass:"tab",class:[{ 'active-view': _vm.viewActive(label) }, (label + "-tab")],attrs:{"type":"button"},on:{"click":function($event){return _vm.setActiveView(label)}}},[_c(icon,{tag:"component",staticClass:"icon",attrs:{"view-active":_vm.viewActive(label)}}),_c('span',[_vm._v(_vm._s(label))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }